<template>
  <div id="app" :style="appStyle">
    <router-view></router-view>
    <LoadingScreen :isLoading="globalLoading" />
    <SystemFooter/>
  </div>
</template>

<script>
import SystemFooter from '@/components/footer_component.vue'
import { ref, provide, watchEffect } from 'vue';
import LoadingScreen from './components/LoadingScreen.vue';

export default {
  components: {
    SystemFooter,
    LoadingScreen
  },
  setup() {
    const isLoading = ref(false);
    provide('isLoading', isLoading);
    
    const appStyle = ref({ 
      '--bg-color': localStorage.getItem('appBackgroundColor') || '#303030',
      '--font-color': localStorage.getItem('appFontColor') || '#FFFFFF'
    });

    watchEffect(() => {
      const bgColor = window.__globalAppSettings?.backgroundColor || 
                     localStorage.getItem('appBackgroundColor') || 
                     '#303030';
      const fontColor = window.__globalAppSettings?.fontColor ||
                      localStorage.getItem('appFontColor') ||
                      '#FFFFFF';
      appStyle.value = { 
        '--bg-color': bgColor,
        '--font-color': fontColor
      };
    });

    return { 
      isLoading,
      globalLoading: isLoading,
      appStyle
    };
  },
  name: 'App',
  data() {
    return {
      checkInterval: null,
      inactivityTimer: null
    }
  },
  methods: {
    checkAuth() {
      const token = localStorage.getItem('authToken');
      const expiry = localStorage.getItem('tokenExpiry');
      // const isLoginPage = this.$route.path === '/login';
      
      // if (!token && !isLoginPage) {
      //   this.$router.push('/login');
      //   return false;
      // }
      
      if (token && expiry && Date.now() > parseInt(expiry)) {
        this.logout();
        return false;
      }
      
      return true;
    },
    
    logout() {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenExpiry');
      if (this.$route.path !== '/login') {
        this.$router.push('/login');
      }
    },
    
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        if (this.checkAuth()) {
          this.logout();
        }
      }, 60 * 60 * 1000); // 1 hour
    }
  },
  mounted() {
    this.checkAuth();
    this.checkInterval = setInterval(() => {
      this.checkAuth();
    }, 5 * 60 * 1000);
    
    this.resetInactivityTimer();
    window.addEventListener('mousemove', this.resetInactivityTimer);
    window.addEventListener('keypress', this.resetInactivityTimer);

    // Initialize with any saved colors
    window.__globalAppSettings = window.__globalAppSettings || {};
    const savedBgColor = localStorage.getItem('appBackgroundColor');
    const savedFontColor = localStorage.getItem('appFontColor');
    
    if (savedBgColor) {
      window.__globalAppSettings.backgroundColor = savedBgColor;
    }
    if (savedFontColor) {
      window.__globalAppSettings.fontColor = savedFontColor;
    }
  },
  beforeUnmount() {  
    clearInterval(this.checkInterval);
    clearTimeout(this.inactivityTimer);
    window.removeEventListener('mousemove', this.resetInactivityTimer);
    window.removeEventListener('keypress', this.resetInactivityTimer);
  }
}
</script>

<style>
body {
    font-family: Poppins;
    font-size: 18px;
    color: var(--font-color) !important;
    background-color: var(--bg-color) !important;
    margin: 0;
    min-height: 100vh;
    display: flex;
    flex-flow: column;
    transition: background-color 0.3s ease, color 0.3s ease;
}

a {
    color: var(--font-color);
}

button {
    color: var(--font-color);
    border-color: var(--font-color);
}
</style>